import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { BetriebLogs, BetriebLogsQuery, BetriebStatus } from "@msc/shared";
import { api } from "../lib/api.js";

export const betriebKeys = {
  all: ["betrieb"] as const,
  status: () => [...betriebKeys.all, "status"] as const,
  logs: (filter: BetriebLogsFilter) => [...betriebKeys.all, "logs", filter] as const,
};

export type BetriebLogsFilter = Partial<Omit<BetriebLogsQuery, "limit">> & { limit?: number };

export function useBetriebStatus() {
  return useQuery<BetriebStatus>({
    queryKey: betriebKeys.status(),
    queryFn: () => api.get<BetriebStatus>("/betrieb/status"),
    refetchInterval: 60_000,
  });
}

/** Nur für `admin`; `enabled` hält andere Rollen von der 403 fern. */
export function useBetriebLogs(filter: BetriebLogsFilter, enabled: boolean) {
  return useQuery<BetriebLogs>({
    queryKey: betriebKeys.logs(filter),
    enabled,
    placeholderData: keepPreviousData,
    queryFn: () => {
      const params = new URLSearchParams();
      for (const [k, v] of Object.entries(filter)) {
        if (v !== undefined && v !== "") params.set(k, String(v));
      }
      const qs = params.toString();
      return api.get<BetriebLogs>(`/betrieb/logs${qs ? `?${qs}` : ""}`);
    },
  });
}
